import { DEV } from 'cc/env';
import { _decorator, Layout, CCFloat, __private, Enum } from 'cc';
import OrientedComponent, { OrientedBaseProperty } from './OrientedComponent';

const { ccclass, property, requireComponent, menu } = _decorator;

@ccclass('OrientedLayoutProperties')
class OrientedLayoutProperties extends OrientedBaseProperty {
    @property({
        tooltip: DEV && '旋轉方向時，是否更新type',
    })
    public updateType: boolean = false;
    @property({
        type: Enum(Layout.Type),
        tooltip: DEV && '旋轉為該方向時，是否該依據設定Layout的模式',
    })
    public type: __private._cocos_ui_layout__Type = Layout.Type.NONE;

    @property({
        tooltip: DEV && '旋轉為該方向時，是否該依據設定Resize模式',
        visible(this: OrientedLayoutProperties) {
            return this.type !== Layout.Type.NONE;
        },
    })
    public updateResizeMode: boolean = false;
    @property({
        type: Enum(Layout.ResizeMode),
        tooltip: DEV && 'Resize模式',
        visible(this: OrientedLayoutProperties) {
            return this.updateResizeMode && this.type !== Layout.Type.NONE;
        },
    })
    public resizeMode: __private._cocos_ui_layout__ResizeMode = Layout.ResizeMode.NONE;

    @property({
        tooltip: DEV && '旋轉為該方向時，是否該依據設定 StartAxis',
        visible(this: OrientedLayoutProperties) {
            return this.type === Layout.Type.GRID;
        },
    })
    public updateStartAxis: boolean = false;
    @property({
        type: Enum(Layout.AxisDirection),
        tooltip: DEV && 'StartAxis',
        visible(this: OrientedLayoutProperties) {
            return this.updateStartAxis && this.type === Layout.Type.GRID;
        },
    })
    public startAxis: __private._cocos_ui_layout__AxisDirection = Layout.AxisDirection.HORIZONTAL;

    @property({
        tooltip: DEV && '旋轉為該方向時，是否該依據設定 Layout 的 AlignHorizontal',
        visible(this: OrientedLayoutProperties) {
            return this.type === Layout.Type.HORIZONTAL;
        },
    })
    public updateAlignHorizontal: boolean = false;
    @property({
        tooltip: DEV && 'AlignHorizontal',
        visible(this: OrientedLayoutProperties) {
            return this.updateAlignHorizontal && this.type === Layout.Type.HORIZONTAL;
        },
    })
    public alignHorizontal: boolean = false;

    @property({
        tooltip: DEV && '旋轉為該方向時，是否該依據設定 Layout 的 AlignVertical',
        visible(this: OrientedLayoutProperties) {
            return this.type === Layout.Type.VERTICAL;
        },
    })
    public updateAlignVertical: boolean = false;
    @property({
        tooltip: DEV && 'AlignVertical',
        visible(this: OrientedLayoutProperties) {
            return this.updateAlignVertical && this.type === Layout.Type.VERTICAL;
        },
    })
    public alignVertical: boolean = false;

    @property({
        tooltip: DEV && '旋轉為該方向時，是否該依據設定Layout的水平間距',
        visible(this: OrientedLayoutProperties) {
            return this.type === Layout.Type.GRID || this.type === Layout.Type.HORIZONTAL;
        },
    })
    public updateSpacingX: boolean = false;
    @property({
        type: CCFloat,
        tooltip: DEV && '水平間距',
        visible(this: OrientedLayoutProperties) {
            return this.updateSpacingX && (this.type === Layout.Type.GRID || this.type === Layout.Type.HORIZONTAL);
        },
    })
    public spacingX: number = 0;

    @property({
        tooltip: DEV && '旋轉為該方向時，是否該依據設定Layout的垂直間距',
        visible(this: OrientedLayoutProperties) {
            return this.type === Layout.Type.GRID || this.type === Layout.Type.VERTICAL;
        },
    })
    public updateSpacingY: boolean = false;
    @property({
        type: CCFloat,
        tooltip: DEV && '垂直間距',
        visible(this: OrientedLayoutProperties) {
            return this.updateSpacingY && (this.type === Layout.Type.GRID || this.type === Layout.Type.VERTICAL);
        },
    })
    public spacingY: number = 0;

    @property({
        tooltip: DEV && '旋轉為該方向時，是否該依據設定Layout的左方邊距',
        visible(this: OrientedLayoutProperties) {
            return this.type === Layout.Type.GRID || this.type === Layout.Type.HORIZONTAL;
        },
    })
    public updatePaddingLeft: boolean = false;
    @property({
        type: CCFloat,
        tooltip: DEV && '左方邊距',
        visible(this: OrientedLayoutProperties) {
            return this.updatePaddingLeft && (this.type === Layout.Type.GRID || this.type === Layout.Type.HORIZONTAL);
        },
    })
    public paddingLeft: number = 0;

    @property({
        tooltip: DEV && '旋轉為該方向時，是否該依據設定Layout的右方邊距',
        visible(this: OrientedLayoutProperties) {
            return this.type === Layout.Type.GRID || this.type === Layout.Type.HORIZONTAL;
        },
    })
    public updatePaddingRight: boolean = false;
    @property({
        type: CCFloat,
        tooltip: DEV && '右方邊距',
        visible(this: OrientedLayoutProperties) {
            return this.updatePaddingRight && (this.type === Layout.Type.GRID || this.type === Layout.Type.HORIZONTAL);
        },
    })
    public paddingRight: number = 0;

    @property({
        tooltip: DEV && '旋轉為該方向時，是否該依據設定Layout的上方邊距',
        visible(this: OrientedLayoutProperties) {
            return this.type === Layout.Type.GRID || this.type === Layout.Type.VERTICAL;
        },
    })
    public updatePaddingTop: boolean = false;
    @property({
        type: CCFloat,
        tooltip: DEV && '上方邊距',
        visible(this: OrientedLayoutProperties) {
            return this.updatePaddingTop && (this.type === Layout.Type.GRID || this.type === Layout.Type.VERTICAL);
        },
    })
    public paddingTop: number = 0;

    @property({
        tooltip: DEV && '旋轉為該方向時，是否該依據設定Layout的下方邊距',
        visible(this: OrientedLayoutProperties) {
            return this.type === Layout.Type.GRID || this.type === Layout.Type.VERTICAL;
        },
    })
    public updatePaddingBottom: boolean = false;
    @property({
        type: CCFloat,
        tooltip: DEV && '下方邊距',
        visible(this: OrientedLayoutProperties) {
            return this.updatePaddingBottom && (this.type === Layout.Type.GRID || this.type === Layout.Type.VERTICAL);
        },
    })
    public paddingBottom: number = 0;

    @property({
        tooltip: DEV && '旋轉為該方向時，是否該依據設定Layout的水平排序方式',
        visible(this: OrientedLayoutProperties) {
            return this.type === Layout.Type.GRID || this.type === Layout.Type.HORIZONTAL;
        },
    })
    public updateHorizontalDirection: boolean = false;
    @property({
        type: Enum(Layout.HorizontalDirection),
        tooltip: DEV && '水平排序方式',
        visible(this: OrientedLayoutProperties) {
            return this.updateHorizontalDirection && (this.type === Layout.Type.GRID || this.type === Layout.Type.HORIZONTAL);
        },
    })
    public horizontalDirection: __private._cocos_ui_layout__HorizontalDirection = Layout.HorizontalDirection.LEFT_TO_RIGHT;

    @property({
        tooltip: DEV && '旋轉為該方向時，是否該依據設定Layout的垂直排序方式',
        visible(this: OrientedLayoutProperties) {
            return this.type === Layout.Type.GRID || this.type === Layout.Type.VERTICAL;
        },
    })
    public updateVerticalDirection: boolean = false;
    @property({
        type: Enum(Layout.VerticalDirection),
        tooltip: DEV && '垂直排序方式',
        visible(this: OrientedLayoutProperties) {
            return this.updateVerticalDirection && (this.type === Layout.Type.GRID || this.type === Layout.Type.VERTICAL);
        },
    })
    public verticalDirection: __private._cocos_ui_layout__VerticalDirection = Layout.VerticalDirection.TOP_TO_BOTTOM;

    @property({
        tooltip: DEV && '旋轉為該方向時，是否該依據設定Layout的Constraint',
        visible(this: OrientedLayoutProperties) {
            return this.type === Layout.Type.GRID;
        },
    })
    public updateConstraint: boolean = false;
    @property({
        type: Enum(Layout.Constraint),
        tooltip: DEV && 'Constraint',
        visible(this: OrientedLayoutProperties) {
            return this.updateConstraint && this.type === Layout.Type.GRID;
        },
    })
    public constraint: __private._cocos_ui_layout__Constraint = Layout.Constraint.NONE;

    @property({
        tooltip: DEV && '旋轉為該方向時，是否該依據設定Layout的ConstraintNum',
        visible(this: OrientedLayoutProperties) {
            return this.type === Layout.Type.GRID;
        },
    })
    public updateConstraintNum: boolean = false;
    @property({
        type: CCFloat,
        tooltip: DEV && 'ConstraintNum',
        visible(this: OrientedLayoutProperties) {
            return this.updateConstraintNum && this.type === Layout.Type.GRID;
        },
    })
    public constraintNum: number = 0;

    @property({
        tooltip: DEV && '旋轉為該方向時，是否該依據設定Layout是否受Scale影響',
        visible(this: OrientedLayoutProperties) {
            return this.type !== Layout.Type.NONE;
        },
    })
    public updateAffectedByScale: boolean = false;
    @property({
        tooltip: DEV && '是否受Scale影響',
        visible(this: OrientedLayoutProperties) {
            return this.updateAffectedByScale && this.type !== Layout.Type.NONE;
        },
    })
    public affectedByScale: boolean = false;
}

@ccclass('OrientedLayout')
@requireComponent(Layout)
@menu('Orientation/OrientedLayout')
export default class OrientedLayout extends OrientedComponent<Layout> {
    @property({ type: OrientedLayoutProperties, group: '橫式' })
    public readonly landscapeProperties: OrientedLayoutProperties = null;
    @property({ type: OrientedLayoutProperties, group: '直式' })
    public readonly portraitProperties: OrientedLayoutProperties = null;
    @property({ tooltip: DEV && '在旋轉時觸發強制更新Layout' })
    public readonly forceUpdateOnOreintationChanged: boolean = false;

    protected updateOrientationProperties(properties: OrientedLayoutProperties) {
        if (properties.updateType) {
            this.target.type = properties.type;
        }
        if (properties.updateResizeMode) {
            this.target.resizeMode = properties.resizeMode;
        }
        if (properties.updateStartAxis) {
            this.target.startAxis = properties.startAxis;
        }
        if (properties.updateAlignHorizontal) {
            this.target.alignHorizontal = properties.alignHorizontal;
        }
        if (properties.updateAlignVertical) {
            this.target.alignVertical = properties.alignVertical;
        }
        if (properties.updateSpacingX) {
            this.target.spacingX = properties.spacingX;
        }
        if (properties.updateSpacingY) {
            this.target.spacingY = properties.spacingY;
        }
        if (properties.updatePaddingLeft) {
            this.target.paddingLeft = properties.paddingLeft;
        }
        if (properties.updatePaddingRight) {
            this.target.paddingRight = properties.paddingRight;
        }
        if (properties.updatePaddingTop) {
            this.target.paddingTop = properties.paddingTop;
        }
        if (properties.updatePaddingBottom) {
            this.target.paddingBottom = properties.paddingBottom;
        }
        if (properties.updateAffectedByScale) {
            this.target.affectedByScale = properties.affectedByScale;
        }
        if (properties.updateHorizontalDirection) {
            this.target.horizontalDirection = properties.horizontalDirection;
        }
        if (properties.updateVerticalDirection) {
            this.target.verticalDirection = properties.verticalDirection;
        }
        if (this.forceUpdateOnOreintationChanged) {
            this.target.updateLayout(true);
        }
        if (properties.updateConstraint) {
            this.target.constraint = properties.constraint;
        }
        if (properties.updateConstraintNum) {
            this.target.constraintNum = properties.constraintNum;
        }
    }

    protected getTarget() {
        return this.getComponent(Layout);
    }
}
